'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("topbarStatus", function () {
  return {
    key: null
  };
});
ngModule.run(function ($rootScope, topbarStatus) {
  $rootScope.$on("$routeChangeSuccess", function (angularEvent, currentRoute, previousRoute) {
    topbarStatus.key = currentRoute.topbarKey || "";
  });
});
ngModule.directive("topbarLogo", function ($location, $translate, $applications) {
  return {
    restrict: 'E',
    replace: true,
    template: '' + '<div class="topbar-logo" ng-click="toHome()">' + '   <img class="taelys-logo" src="/images/logo_taelys.svg"/>' + '</div>',
    link: function link($scope, $el, $attrs) {
      $scope.toHome = function () {
        $location.path('/');
      };
      var appId = $applications.getCurrentAppId();
      $scope.appLabel = $translate("topbar.appLabel." + appId);
    }
  };
});
ngModule.directive("topbarNav", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<ul class="topbar-nav" ng-transclude></ul>'
  };
});
ngModule.directive("topbarNavElem", function (topbarStatus, iconUtils) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      key: "@",
      url: "@",
      label: "@",
      title: "@",
      /**
       * permet de choisir une couleur spécifique pour l'icone
       */
      color: "@",
      icon: "@"
    },
    template: '' + '<li class="topbar-nav-el" ng-class="{ selected : selected }">' + '   <a href="{{::url}}">' + '       <i class="nav-icon {{::fullIcon}} {{::color}}"></i>' + '       <span ng-if="::label">{{::label | translate}}</span>' + '       <span ng-if="::title">{{::title}}</span>' + '   </a>' + '</li>',
    link: function link($scope, $el, $attrs) {
      $scope.fullIcon = iconUtils.getFullName($scope.icon);
      $scope.$watch(function () {
        return topbarStatus.key;
      }, function (topbarKey) {
        $scope.selected = topbarKey === $scope.key;
      });
    }
  };
});
ngModule.directive("topbarUserboxContent", function ($session, $authz) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '' + '<div class="userbox-content">' + '   <div class="client-picture-box">' + '       <file-image img-scale img-width="100" img-height="42" class="client-picture" url="/rest/compte/current/icon"></file-image>' + '   </div>' + '   <span class="client-name" ng-class="{\'vueClient\':isVueClient}">{{username}}</span>' + '   <i class="fa fa-caret-down"></i>' + '</div>',
    link: function link($scope, $el, $attrs) {
      var user = $session.getUser(),
        compte = $session.getCompte();
      $scope.username = compte && (compte.nomClientCourt || compte.nomClient) || user.prenom + " " + user.nom;
      $scope.isVueClient = $authz.hasRole("INTRA_TAELYS_AVEC_VUE_CLIENT");
    }
  };
});
ngModule.directive("topbarEnvironment", function ($session) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: "<div class=\"environment environnement-{{::environment}}\" ng-if=\"::environment!=='prod'\">{{::environment|uppercase}}</div>",
    link: function link($scope, $el, $attrs) {
      $scope.environment = $session.getEnvironment();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/topbar/topbar.js
// module id = 3023
// module chunks = 13